import React from "react";
import { getAffiliationColor } from "./helpers";

class ProgressBar extends React.Component {
  render() {
    const percentage = this.props.percentage;

    return (
      <div className="progress-bar">
        <div className="bar">
          <div
            style={{
              backgroundColor: getAffiliationColor(''),
              width: percentage + "%"
            }}
            ></div>
          {parseInt(percentage) < 100 && (
            <div
              style={{
                backgroundColor: "#f1f2f2",
                width: 100 - percentage + "%"
              }}
            ></div>
          )}
        </div>
      </div>
    );
  }
}

export default ProgressBar;
